import React, { useState } from 'react';
import { Col, Divider, Row } from 'antd';

import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { grey, purple } from './constants';
import bilingualBannerUrl from './bilingual-asia-miles.jpg';
import bilingualBannerEnUrl from './english-asia-miles.png';
import AsiaMilesDrawer from './AsiaMilesDrawer';
import { StyledButton } from '../../Styled';
import ImageEdit from 'assets/images/business/edit.svg';

export default function AsiaMilesCard(props) {
  const {
    membershipNumber,
    onMembershipNumberChange,
    reward,
    firstName,
    lastName,
    onFirstNameChange,
    onLastNameChange
  } = props;
  const isLoggedIn = !!membershipNumber && membershipNumber !== '';
  const [open, setOpen] = useState(false);

  const { t } = useTranslation();

  const renderAccountDetails = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer'
      }}
      onClick={() => setOpen(true)}>
      <span
        style={{ fontWeight: 300, fontSize: 16, font: 'GenSenRoundedJP-L' }}>
        <CheckOutlined
          style={{
            backgroundColor: '#2ddbbb',
            color: 'white',
            borderRadius: '50%',
            padding: 5,
            fontSize: 11,
            marginRight: 8,
            marginBottom: 3
          }}
        />
        {membershipNumber}
      </span>
      <span
        style={{
          color: purple,
          cursor: 'pointer',
          padding: 8,
          marginRight: -8
        }}>
        <img
          className="image-filter second"
          src={ImageEdit}
          style={{ marginRight: 6, height: 12, verticalAlign: 'bottom' }}
          alt="edit_icon"
        />
        {t('button.edit')}
      </span>
    </div>
  );

  const renderDetails = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}>
      <img
        className="campaign-img"
        src={t('key') === 'en' ? bilingualBannerEnUrl : bilingualBannerUrl}
        alt=""
        style={{ maxWidth: '40%', marginBottom: 8, minWidth: 153 }}
      />
      <span
        style={{
          color: grey,
          fontSize: '12px',
          marginBottom: 8
        }}>
        {t('campaigns.asia_miles.card.call_for_action')}
      </span>
    </div>
  );

  const renderPoints = () => (
    <div style={{ display: 'flex' }}>
      <span
        style={{
          color: grey,
          fontSize: 18,
          fontWeight: 500,
          width: 'max-content',
          lineHeight: '58px'
        }}>
        {t('campaigns.asia_miles.card.est') + ' '}
      </span>
      <span
        style={{
          color: purple,
          fontSize: 40,
          fontWeight: 200,
          width: 'max-content',
          lineHeight: '44px'
        }}>
        {reward}
      </span>
      <span
        style={{
          color: grey,
          fontSize: 18,
          fontWeight: 500,
          width: 'max-content',
          lineHeight: '58px'
        }}>
        {' ' + t('campaigns.asia_miles.card.miles')}
      </span>
    </div>
  );

  return (
    <div>
      <Row
        type="flex"
        align="bottom"
        style={{
          paddingBottom: '15px',
          borderBottom: '1px solid #ccc'
        }}>
        <Col
          span={24}
          style={{
            fontSize: '20px',
            fontWeight: 700
          }}>
          <Row>
            <span>{t('campaigns.asia_miles.card.header')}</span>
          </Row>
        </Col>
      </Row>
      <div
        style={{
          padding: 16,
          marginBottom: 20,
          textAlign: 'center',
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
          backgroundColor: '#fff',
          marginTop: 15
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          {renderDetails()}
          {renderPoints()}
        </div>
        {!isLoggedIn && (
          <div style={{ marginTop: 15 }}>
            <StyledButton
              type="primary"
              ghost
              style={{ color: '#57D7DD', borderColor: '#57D7DD' }}
              onClick={() => setOpen(true)}>
              {t('campaigns.asia_miles.card.action')}
            </StyledButton>
          </div>
        )}
        {isLoggedIn && <Divider style={{ margin: '16px 0' }} />}
        {isLoggedIn && renderAccountDetails()}
        <AsiaMilesDrawer
          initValue={{ membershipNumber, firstName, lastName }}
          open={open}
          bannerUrl={
            t('key') === 'en' ? bilingualBannerEnUrl : bilingualBannerUrl
          }
          onClose={() => setOpen(false)}
          onSubmit={newValue => {
            const { membershipNumber, firstName, lastName } = newValue;
            onMembershipNumberChange(membershipNumber);
            onFirstNameChange(firstName);
            onLastNameChange(lastName);
          }}
        />
      </div>
    </div>
  );
}
